export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12479.fd6c3187.jpg";